import React, {ReactNode} from 'react';
import Page, {PageType} from '@episerver/spa-core/Page';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import CmsHomePageData from 'app/Models/Content/CmsHomePageData';
import TypeMapper from 'app/Models/Content/TypeMapper';

export default class CmsHomePage extends Page<CmsHomePageData> {
  protected pageType = PageType.Home;

  public render(): Array<ReactNode> {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo(0, 0);
    }
    // let t = new TypeMapper();
    // t.createInstanceAsync(this.props.data).then((i) => {});

    return [
      <ContentArea
        noWrap
        key='topContentArea'
        context={this.props.context}
        data={this.props.data.topContentArea}
        propertyName='topContentArea'
      />,
      <ContentArea
        key='mainContentArea'
        context={this.props.context}
        data={this.props.data.mainContentArea}
        propertyName='mainContentArea'
      />,
      <ContentArea
        noWrap
        key='bottomContentArea'
        context={this.props.context}
        data={this.props.data.bottomContentArea}
        propertyName='bottomContentArea'
      />,
    ];
  }
}
